"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stripClassNames = void 0;
var classAttrRegExp = / class="([^"]*)"/g;

/**
 * Remove all class names that do not start with one of preserveClassNames
 * (`slate-` by default)
 */
var stripClassNames = function stripClassNames(html, _ref) {
  var _ref$preserveClassNam = _ref.preserveClassNames,
    preserveClassNames = _ref$preserveClassNam === void 0 ? ['slate-'] : _ref$preserveClassNam;
  if (preserveClassNames.length === 0) {
    return html.replaceAll(classAttrRegExp, '');
  }
  var preserveRegExp = new RegExp(preserveClassNames.map(function (cn) {
    return "^".concat(cn);
  }).join('|'));
  return html.replaceAll(classAttrRegExp, function (match, className) {
    var classesToKeep = className.split(/\s+/).filter(function (cn) {
      return preserveRegExp.test(cn);
    });
    return classesToKeep.length === 0 ? '' : " class=\"".concat(classesToKeep.join(' '), "\"");
  });
};
exports.stripClassNames = stripClassNames;